const CategoryProductSang = [
    {
        ID: -1 , 
        ParentID: "",
        Name: " همه موارد",
    },
    {
        ID: 1001 , 
        ParentID: "",
        Name: " سنگ تراورتن ",
    },
    {
        ID: 1002 , 
        ParentID: "",
        Name: " سنگ مرمریت ",
    },
    {
        ID: 1003 , 
        ParentID: "",
        Name: " سنگ گرانیت ",
    },
    {
        ID: 1004 , 
        ParentID: "",
        Name: " سنگ مرمر ",
    },
    // {
    //     ID: 1005 , 
    //     ParentID: "",
    //     Name: " سنگ عباس آباد ",
    // },
    // {
    //     ID: 1006 , 
    //     ParentID: "",
    //     Name: " سنگ لاشتر ",
    // },
]
export default CategoryProductSang;